import { render, staticRenderFns } from "./FlightCustomerContactPhones.vue?vue&type=template&id=0ed41cf4&scoped=true&"
import script from "./FlightCustomerContactPhones.vue?vue&type=script&lang=js&"
export * from "./FlightCustomerContactPhones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed41cf4",
  null
  
)

/* custom blocks */
import block0 from "./FlightCustomerContactPhones.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VImg,VRow,VSelect,VTextField})
